// en-US.js
export default {
    homepage : {
        header_menu: {
            header_menu_1: [
                {
                    id: 1,
                    name: 'Home',
                    links: '/',
                },
                {
                    id: 2,
                    name: 'News',
                    links: '#',
                },
                {
                    id: 3,
                    name: 'Events',
                    links: '#',
                },
                {
                    id: 4,
                    name: 'Directory',
                    links: '#',
                },
            ],
            header_menu_2: [
                {
                    id: 5,
                    name: 'Contributors',
                    links: '#'
                },
                {
                    id: 6,
                    name: 'Premium users',
                    links: '#'
                },
            ]
        },
        slider: {
            heading: "Welcome to",
            introduction_1: {
                sentence: [
                    "Welcome to Luncsphere,  the hub for the entire Luna Classic ecosystem, fostering innovation, unity,  engagement and growth. Here, you can stay up-to-date with the latest developments in the Luna Classic ecosystem, such as the launch of new applications, upcoming AMAs, NFT projects or upgrades to the network. "
                ],
                image : "guardian_1.png"
            },
            introduction_2: {
                sentence: [
                    'This platform also serves as a space for members of the Luna Classic community to connect with other community members to share ideas, chat or meet up in their local area. In addition it offers a Cryptocurrency-focused freelance marketplace, connecting clients seeking crypto-related services with freelancers who have the relevant skills and expertise. ',
                    'Our goal is to foster a supportive and collaborative environment that empowers the Luna Classic community to grow and thrive',
                ],
                image : "guardian_2.png"
            }
        },
        contributors: {
            heading : "Luncsphere for Contributors",
            body: 'As a validator, developer, NFT project, exchange or influencer, Luncsphere is the perfect tool to share your news, tutorials or events and connect with fellow Lunc thought leaders.',
            button : 'Register as a contributor'
        },
        premium_users: {
            heading: 'Luncsphere Premium',
            heading_below: 'For NFT holders and Premium subscribers, Luncsphere offers a range of additional features, exclusive launches, events and services.',
            body : {
                luncmeet: {
                    heading: "Luncmeets",
                    body: "Luncmeets offers premium users the opportunity to search and engage with like-minded folk within the Luna Classic community. Search for other Premium users by interest or location. Share knowledge and experience and arrange meet ups either online or in person.",
                    picture_description: 'Top Premium Users'
                },
                marketplace: {
                    heading: "Marketplace",
                    body: "Luncmarket place operates similarly to existing freelance platforms such as Upwork or Fiverr, but with the added benefit of offering services for Luna Classic payments. Freelancers can sign up and create a profile, offering their skills to potential clients within Luncsphere. Clients can also sign up and post jobs and gigs for freelancers to bid on.",
                    picture_description: "Top Premium Users"
                },
                gigs: {
                    heading: 'Top Freelance Gigs'
                }
            },
            footer: {
                button_description: 'Join Premium Users now!',
                button: 'Premium Users'
            }
        },
        news: {
            heading: 'Lunc News',
            body: 'Keep your finger on the pulse for all developments and updates relating to the Luna Classic Community. \n Your centralised news source for all things Lunc.',
            footer: {
                button: "See All News"
            }
        },
        events: {
            heading: 'Lunc Events',
            body: 'Stayed tuned in to all events through our Luncsphere calendar. For new NFT collections, DAPP launches, upgrades, AMA’s and tutorials relating to the Luna Classic blockchain.',
            footer: {
                button: 'See More Events'
            }
        },
        directory: {
            heading: 'Lunc Directory',
            body: 'Find the hottest contributors to follow in the Luna Classic community and gain access to the content that matters to remain educated and informed about your Lunc investments.',
            footer: {
                icons: [
                    {
                        icon: './assets/icon/console.png',
                        name: 'Gaming'
                    },
                    {
                        icon: './assets/icon/nft_card.png',
                        name: 'NFT'
                    },
                    {
                        icon: './assets/icon/location.png',
                        name: 'Market Place'
                    },
                    {
                        icon: './assets/icon/coding.png',
                        name: 'Developer Team'
                    },
                    {
                        icon: './assets/icon/influence.png',
                        name: 'Influencer'
                    },
                    {
                        icon: './assets/icon/payment.png',
                        name: 'Payment Providers'
                    },
                ],
                button: 'Search Now'
            }
        },
        nft_showcase: {
            heading: 'NFT Showcase'
        }
    },
    contributor_login: {
        header: "Contributor Login",
        body: {
            description: "Welcome, contributors! Login and unlock a world of possibilities. Share media, events, updates, and news with the Luna Classic community. Join us now and make your mark in Luna Classic's journey!",
            user_name: "User Name",
            password: "Password",
            forgot_password: "Forgot Password?"
        },
        footer: {
            button: "Login",
            register_1: "Not Contributors yet?",
            register_2: "Register"
        }
    },
    contributor_register: {
        header: {
            title: "Contributors Registration",
            description: "Calling all contributors! register now and be part of the movement"
        },
        body: {
            label: {
                first_name: "First name",
                last_name: "Last name",
                email: "Email",
                password: 'Password',
                role: "Which of the following best describes you",
                describe: "Please describe why you think you would be a valuable contributor to the Luncsphere community."
            }
        },
        footer: {
            button: "Register"
        }
    },
    contributor_register_request: {
        title: "We've sent your request.",
        body: "Please wait. We will send admin's approval to your email inbox. This will take 2 or 3 hours."
    },
    contributor_forgot_password: {
        title: "Forgot Password?",
        body: "We will send an email to your email address shortly.",
        label: "Your email address"
    },
    contributor_forgot_request: {
        title: "We've sent your request.",
        body: "Please wait. We will send an email to your email inbox. Please check your email."
    },
    contributor_reset_password: {
        title: "Reset password",
        label: {
            button1: "New Password",
            button2: "Confirm Password",
        }
    },
    contributor_create_profile: {
        title: "Create your profile",
        label: {
            button1: 'Username',
            button2: 'Images',
            button3: 'Description',
            social_links: [
                'Twitter',
                'Youtube',
                'Discord',
                'Telegram',
            ],
            button4: 'Save Profile'
        }
    }
}